import React, { useEffect } from "react";
import { Credit } from "../components/credit/Credit";
import { CreditState } from "../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../stores/credit/credit.store";
import { initCreditThunk } from "../stores/credit/thunks/init-credit.thunk";
import { togglePopup } from "../stores/credit/credit.reducer";
import { Popup } from "../components/account/Popup";
import { useCreditSelector } from "../stores/product/product.store";

const CreditPage = () => {
    const isOpen = useCreditSelector((state: CreditState) => state.popup.isOpen);
    const page = useCreditSelector((state: CreditState) => state.page);
    const dispatch = useCreditDispatch();

    useEffect(() => {
        dispatch(initCreditThunk());
    }, [dispatch]);

    const close = (cross: boolean) => {
        if(!cross && page > 1) {
            return ;
        }
        dispatch(togglePopup(false));
    }

    return (
        <>
            { isOpen &&
                <Popup onClose={ close }>
                    <div className="max-w-full md:max-w-[600px] flex justify-center w-full">
                        <Credit/>
                    </div>
                </Popup>
            }
        </>
    );
}

export default CreditPage;